$(function() {
  $('.add-to-cart').click(function() {
    if(typeof(products) === 'undefined') {
      return false;
    }

    const modalProduct = products[$(this).data('index')];
    var downcaseOptions = modalProduct.options.map(function(val, i) { return val.replace(/ /g, '').toLowerCase() });
    var hasStyle = downcaseOptions.indexOf('style') >= 0 || downcaseOptions.indexOf('model') >= 0;
    var hasColor = downcaseOptions.indexOf('color') >= 0;
    var hasSize = downcaseOptions.indexOf('size') >= 0 || downcaseOptions.indexOf('shoesize') >= 0;
    var styleIndex = -1;
    var colorIndex = -1;
    var sizeIndex = -1;
    var currentWindowPos = $(window).scrollTop();

    if(hasStyle) {
      styleIndex = downcaseOptions.indexOf('style') >= 0 ? downcaseOptions.indexOf('style') : downcaseOptions.indexOf('model');
    }
    if(hasColor) {
      colorIndex = downcaseOptions.indexOf('color');
    }
    if(hasSize) {
      sizeIndex = downcaseOptions.indexOf('size') >= 0 ? downcaseOptions.indexOf('size') : downcaseOptions.indexOf('shoesize');
    }
    
    if($(window).width() >= 800) {
      $('body').css('overflow-y', 'hidden');
    } else {
      $('#main-container').css('overflow-y', 'hidden');
    }

    $('.product-modal-overlay').fadeIn(300);

    function getVariantTitle() {
      var variantTitle = '';

      $.each(downcaseOptions, function() {  
        if($('.modal-form input[name=' + this.replace(/ /g, '') + ']:checked').length > 0) {
          variantTitle += $('.modal-form input[name=' + this + ']:checked').val() + ' / ';
        } else {
          variantTitle += $('.modal-form input[name=' + this + ']').first().val() + ' / ';
        }
      });

      variantTitle = variantTitle.substring(0, variantTitle.length - 3);
      return variantTitle;
    }

    // Generate inputs

    (function() {
      $('.product-modal-title h2').text(modalProduct.title);
      
      $.each(downcaseOptions, function() {
        const option = this.toString();

        $('.modal-form').append('<span class="option-wrapper" data-wrapper="' + option + '"></span>');
        $('span[data-wrapper=' + option + ']').append('<span class="option-title" data-title="' + option + '"></span>');

        var title = '';

        if(option === 'style' || option === 'model') {
          title = 'Select your style';
        } else if(option.indexOf('size') >= 0) {
          title = 'Pick your size';
        } else {
          title = option;
        }

        $('span[data-title=' + option + ']').text(title);

        if(option === 'style' || option === 'model') {
          $('span[data-wrapper=' + option + ']').append('<span class="style-input-group" data-group="' + option + '"></span>');
        } else if(option === 'color') {
          $('span[data-wrapper=' + option + ']').append('<span class="color-input-group" data-group="' + option + '"></span>');
        } else {
          $('span[data-wrapper=' + option + ']').append('<span class="input-group" data-group="' + option + '"></span>');
        }
      });

      $.each(modalProduct.options_with_values, function(index, option) {
        option = option.name.replace(/ /g, '').toLowerCase();

        $.each(this.values, function(i, val) {
          $('span[data-group="' + option +'"]').append('<input type="radio" id="modal-' + option + '-' + i + '" name="' + option + '" value="' + val + '">');
          if(i === 0) {
            $('input[name=' + option + ']').prop('checked', true);
          }

          if(option === 'style' || option === 'model' || option === 'color') {
            var label = '<label for="modal-' + option + '-' + i + '" class="' + option + '-element"><span class="' + option + '-value">' + val + '</span><div class="tooltip">' + val + '</div>';
            if(option === 'color') {
              label += '<span class="color"></span>';
            }
            $('span[data-group="' + option +'"]').append(label + '</label>');
          } else {
            $('span[data-group="' + option +'"]').append('<label for="modal-' + option + '-' + i + '" class="element ' + option + '-element">' + val + '</label>');
          }
        });
      });

      if(hasSize) {
        $('.modal-form').append('<p class="size-error">Please pick your size!</p>');
      }

      $('.modal-form').append('<input type="submit" value="Add to cart">');
    })();

    // Update price

    function updatePrice() {
      $.each(modalProduct.variants, function() {
        const variant = this;
        if(getVariantTitle() === variant.title) {      
          if(variant.compare_at_price > variant.price) {
            $('.modal-product-price .was-price').text('$' + (variant.compare_at_price / 100).toFixed(2)).show();
            $('.modal-product-price .sale-banner').text('Save $' + ((variant.compare_at_price - variant.price) / 100).toFixed(2)).show();
          } else {
            $('.modal-product-price .was-price').hide();
            $('.modal-product-price .sale-banner').hide();
          }
          $('.modal-product-price .current-price').text('$' + (variant.price / 100).toFixed(2));

          return false;
        }
      });
    }

    updatePrice();

    $('[class*=modal-group] input').change(function() {
      updatePrice();
    });

    // Ajust product input grid

    function ajustInputGrid(group, width) {
      if($(window).width() >= 800) {
        return false;
      }

      const columnGap = parseInt(group.css('column-gap'));
      const groupWidth = group.width();
      const styleGridPerRow = parseInt((groupWidth + columnGap) / (width + columnGap));

      group.css('grid-template-columns', 'repeat(' + styleGridPerRow + ', ' + width + 'px)');
    }

    ajustInputGrid($('.style-input-group'), 80);
    ajustInputGrid($('.color-input-group'), 42);

    $(window).resize(function() {
      ajustInputGrid($('.style-input-group'), 80);
      ajustInputGrid($('.color-input-group'), 42);
    });
    
    // Set style background

    (function() {
      if(hasStyle) {
        $.each($('.modal-form .' + downcaseOptions[styleIndex] + '-element'), function() {
          const styleInputVal = $(this).prev('input').val();
          const styleLabel = $(this);

          $.each(modalProduct.variants, function() {
            if(this['option' + (styleIndex + 1)] === styleInputVal) {
              styleLabel.css('background-image', 'url(' + this.featured_image.src + ')');
              return false;
            }
          });
        });
      }
    })();
    
    // Set color

    (function() {
      if(hasColor) {
        const colorLabels = $('.modal-form .' + downcaseOptions[colorIndex] + '-element');
        var listedColor = true;

        $.each(colorLabels, function() {
          const colorInputVal = $(this).prev('input').val().toLowerCase();
          listedColor =  listedColor && $.map(COLOR, function(val, key) { return key }).indexOf(colorInputVal) >= 0;
        });

        if(listedColor) {
          $.each(colorLabels, function() {
            const colorInputVal = $(this).prev('input').val().toLowerCase();
            $(this).children('.color').css('background-color', COLOR[colorInputVal]);
          });
        } else {
          $.each(colorLabels, function() {
            $(this).parent('[class*=input-group]').removeAttr('class').addClass('input-group');
            $(this).removeAttr('class').addClass('element');
          });
        }
      }
    })();

    // Product form submit

    (function() {
      $('.modal-form').submit(function(e) {
        if($('.modal-form input[name=' + downcaseOptions[sizeIndex] + ']').length > 0 && $('.modal-form input[name=' + downcaseOptions[sizeIndex] + ']:checked').length === 0) {
          $('.size-error').fadeIn(300);
          e.preventDefault();
        } else {
          $.each(modalProduct.variants, function() {
            if(this.title === getVariantTitle()) {
              $('.modal-form').prepend('<input type="hidden" name="id" value="' + this.id + '">');
              return false;
            }
          });
        }
      });
    })();

    // Change options

    (function() {
      $('.modal-form input[name=' + downcaseOptions[sizeIndex] + ']:checked').prop('checked', false);

      function changeOptions(index) {
        const nextInput = $('.modal-form input[name=' + downcaseOptions[index + 1] + ']:checked');
        var nextOptions = [];

        $.each(modalProduct.variants, function() {
          const variant = this;
          var condition = true;

          for(var i = 0; i <= index; i++) {
            const checkedInput = $('.modal-form input[name=' + downcaseOptions[i] + ']:checked');
            condition = condition && variant['option' + (i + 1)] === checkedInput.val();
          }

          if(condition) {
            $.merge(nextOptions, [variant['option' + (index + 2)]]);
          }        
        });

        $('.modal-form input[name=' + downcaseOptions[index + 1] + ']').next('label').show();

        $.each($('.modal-form input[name=' + downcaseOptions[index + 1] + ']'), function() {
          if(nextOptions.indexOf($(this).val()) === -1) {
            $(this).next('label').hide();
          }
        });

        if(nextInput.next('label:visible').length === 0) {
          if(sizeIndex === index + 1) {
            $('.modal-form input[name=' + downcaseOptions[index + 1] + ']').prop('checked', false);
          } else {
            $('.modal-form input[name=' + downcaseOptions[index + 1] + ']').first().prop('checked', true).trigger('change');
          }
        }

        if(index === 0) {
          changeOptions(1);
        }
      }

      $.each(downcaseOptions, function(index, option) {
        if(index < downcaseOptions.length - 1) {
          changeOptions(index);
          $('.modal-form input[name=' + downcaseOptions[index] + ']').change(function() {
            changeOptions(index);
          });
        }

        if(index === sizeIndex) {
          $('.modal-form input[name=' + downcaseOptions[index] + ']').change(function() {
            $('.size-error').stop(true).hide();
          });
        }
      });
    })();
    
    // Cancel modal
    
    $('.product-modal-overlay, .cancel-btn').click(function(e) {
      if(e.target === this) {
        $('.product-modal-overlay').stop(true).hide();
        $('.modal-form .option-wrapper').remove();
        $('.modal-form .size-error').remove();
        $('.modal-form input[type=submit]').remove();
        
        if($(window).width() >= 800) {
          $('body').css('overflow-y', 'auto');
        } else {
          $('#main-container').css('overflow-y', 'unset');
          $(window).scrollTop(currentWindowPos);
        }
      }
    });
  });
});